if (!customElements.get('wlsn-url-params')) {
    class WLSNURLParams extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        init() {
            this.addUrlParam();
        }

        addUrlParam() {
            const value = this.dataset.urlParam;

            console.log('[URL PARAM] value:', value);

            if (!value) return;

            const [key, paramValue] = value.split('=');

            if (!key || !paramValue) return;

            const url = new URL(window.location.href);

            url.searchParams.set(key, paramValue);

            window.history.replaceState({}, '', url.toString());
        }
    }

    customElements.define('wlsn-url-params', WLSNURLParams);
}